import React, { useState } from "react";
import { FaEnvelope, FaMapMarkerAlt, FaMobileAlt } from "react-icons/fa";
import { useTranslation } from "react-i18next";
import SEO from "./SEO";
import LanguageSwitcher from "./LanguageSwitcher";

const MAP_URLS = {
  gyurjyan: "https://yandex.com/maps/-/CXQIRWy-",
  arshakunyats: "https://yandex.com/maps/-/CXQIZYK-",
  itpark: "https://yandex.com/maps/-/CXQIZBoY",
};

const MAP_WIDGET_URLS = {
  gyurjyan: "https://yandex.com/map-widget/v1/-/CXQIRWy-",
  arshakunyats: "https://yandex.com/map-widget/v1/-/CXQIZYK-",
  itpark: "https://yandex.com/map-widget/v1/-/CXQIZBoY",
};

const Contact = () => {
  const { t } = useTranslation();
  const [activeMapWidget, setActiveMapWidget] = useState(MAP_WIDGET_URLS.gyurjyan);

  return (
    <div className="contact-row-container">
      <SEO
        title={t("contact_page_title")}
        description={`${t("addr_masiv")}, ${t("addr_mamuli")}, ${t("addr_itpark")}. ${t("tel")} (+374 60) 446685, ${t("mob")} (+374 91) 407038`}
      />
      <div className="fh5co-more-contact">
        <div className="fh5co-narrow-content">
          <div className="row">
            <div
              className="col-md-3"
              style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                textAlign: "center",
                marginBottom: "20px",
              }}
            >
              <div className="row">
                <FaEnvelope
                  size="1.5em"
                  style={{
                    marginBottom: "1rem",
                    display: "block",
                    color: "#02B1EC",
                  }}
                />
              </div>
              <div className="row">
                <p className="contact-text">
                  <a className="contact-email" href="mailto:info@tparan.am">
                    info@tparan.am
                  </a>
                  <br />
                  <a className="contact-email" href="mailto:corporate@tparan.am">
                    corporate@tparan.am
                  </a>
                  <br />
                  <a className="contact-email" href="mailto:marketing@tparan.am">
                    marketing@tparan.am
                  </a>
                  <br />
                  <a className="contact-email" href="mailto:tparan@tparan.am">
                    tparan@tparan.am
                  </a>
                </p>
              </div>
            </div>
            <div
              className="col-md-3"
              style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                textAlign: "center",
                marginBottom: "20px",
              }}
            >
              <div className="row">
                <FaMapMarkerAlt
                  size="1.5em"
                  style={{
                    marginBottom: "1rem",
                    display: "block",
                    color: "#02B1EC",
                  }}
                />
              </div>
              <div className="row">
                <p className="contact-text">
                  <a
                    href={MAP_URLS.gyurjyan}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="contact-address"
                    onClick={() => setActiveMapWidget(MAP_WIDGET_URLS.gyurjyan)}
                  >
                    {t("addr_masiv")}
                  </a>
                  <br />
                  <a
                    href={MAP_URLS.arshakunyats}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="contact-address"
                    onClick={() => setActiveMapWidget(MAP_WIDGET_URLS.arshakunyats)}
                  >
                    {t("addr_mamuli")}
                  </a>
                  <br />
                  <a
                    href={MAP_URLS.itpark}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="contact-address"
                    onClick={() => setActiveMapWidget(MAP_WIDGET_URLS.itpark)}
                  >
                    {t("addr_itpark")}
                  </a>
                </p>
              </div>
            </div>
            <div
              className="col-md-3"
              style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                textAlign: "center",
                marginBottom: "20px",
              }}
            >
              <div className="row">
                <FaMobileAlt
                  size="1.5em"
                  style={{
                    marginBottom: "1rem",
                    display: "block",
                    color: "#02B1EC",
                  }}
                />
              </div>
              <div className="row">
                <p className="contact-text">
                  {t("mob")} <a className="contact-phone" href="tel:+37491407038">(+374 91) 407038</a>
                  <br />
                  <a className="contact-phone" href="tel:+37493407038">(+374 93) 407038</a>
                  <br />
                  {t("tel")} <a className="contact-phone" href="tel:+37460446685">(+374 60) 446685</a>
                </p>
              </div>
            </div>
            <div className="col-md-3 text-center top-bar-social-lang" style={{ marginBottom: "20px" }}>
              <div className="social-media">
                <a href="https://instagram.com/tparan.am" target="_blank" rel="noopener noreferrer">
                  <img width="44" height="44" src="https://img.icons8.com/fluency/144/instagram-new.png" alt="instagram" />
                </a>

                <a href="https://facebook.com/tparan.am" target="_blank" rel="noopener noreferrer">
                  <img width="44" height="44" src="https://img.icons8.com/fluency/144/facebook-new.png" alt="facebook" />
                </a>
              </div>

              <div className="desktop-lang-flags">
                <LanguageSwitcher direction="vertical" />
              </div>

              <div className="mobile-lang-flags">
                <LanguageSwitcher direction="horizontal" />
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* <iframe title="maps" src="https://www.google.com/maps/d/u/0/embed?mid=1xqKP3svNQrV9HgllYMo3gvD1rsyM23bw" className="contact-map"></iframe> */}
      {/* <iframe title="maps" src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d6095.6685248753365!2d44.55920539690929!3d40.19050173171598!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x406aa32ddef56d9f%3A0xa2ac7c05d7063025!2z1Y_VutWh1oDVodW2LmFtINWG1bjWgCDVhtW41oDWhCDVtNWh1b3VttWh1bPVtdW41oLVsg!5e0!3m2!1sen!2sam!4v1770303672599!5m2!1sen!2sam" className="contact-map" allowFullScreen="" loading="lazy" referrerPolicy="no-referrer-when-downgrade"></iframe> */}
      <div
        style={{
          left: 0,
          width: "100%",
          height: 0,
          position: "relative",
          paddingBottom: "75%",
        }}
      >
        <iframe
          title="maps"
          src={activeMapWidget}
          style={{top: 0, left: 0, width: "100%", height: "100%", position: "absolute", border: 0}}
          className="contact-map"
          allowFullScreen=""
          referrerPolicy="no-referrer-when-downgrade"
        ></iframe>
      </div>
    </div>
  );
};

export default Contact;
